import { useRef } from "react";
import { FileUp, X, FileText } from "lucide-react";

export const DOC_TYPES = [
  ["carte_pro", "Carte professionnelle"],
  ["patente", "Patente"],
  ["rne", "Registre national (RNE)"],
  ["diplome", "Diplôme"],
  ["autre", "Autre justificatif"],
];

export default function DocumentsPicker({ docs, setDocs }) {
  const ref = useRef();
  const add = (files) => {
    const next = [...docs];
    for (const f of files) {
      if (next.length >= 6) break;
      if (f.size > 10 * 1024 * 1024) continue;
      next.push({ file: f, doc_type: "carte_pro" });
    }
    setDocs(next);
  };
  const update = (i, v) => setDocs(docs.map((d, j) => (j === i ? { ...d, doc_type: v } : d)));

  return (
    <div data-testid="reg-documents">
      <label className="text-sm font-semibold text-slate-700">Pièces justificatives de l'exercice</label>
      <p className="text-xs text-slate-500 mt-0.5">Carte professionnelle, patente, RNE… PDF ou image, 10 Mo max par fichier (6 max).</p>
      <div className="mt-2 space-y-2">
        {docs.map((d, i) => (
          <div key={i} className="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2" data-testid={`reg-doc-${i}`}>
            <FileText className="h-4 w-4 text-indigo-600 shrink-0" />
            <span className="text-xs font-medium text-slate-700 truncate flex-1">{d.file.name}</span>
            <select value={d.doc_type} onChange={(e) => update(i, e.target.value)} data-testid={`reg-doc-type-${i}`}
              className="h-8 text-xs rounded-md border border-slate-300 bg-white px-2">
              {DOC_TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
            <button type="button" onClick={() => setDocs(docs.filter((_, j) => j !== i))} data-testid={`reg-doc-remove-${i}`}
              className="p-1 rounded hover:bg-slate-200 text-slate-500 transition-colors duration-200"><X className="h-3.5 w-3.5" /></button>
          </div>
        ))}
      </div>
      <input ref={ref} type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.webp" className="hidden" data-testid="reg-doc-input"
        onChange={(e) => { add(Array.from(e.target.files)); e.target.value = ""; }} />
      {docs.length < 6 && (
        <button type="button" onClick={() => ref.current?.click()} data-testid="reg-doc-add"
          className="mt-2 w-full h-11 rounded-lg border-2 border-dashed border-slate-300 hover:border-indigo-400 hover:bg-indigo-50/40 text-sm font-semibold text-slate-600 flex items-center justify-center gap-2 transition-colors duration-200">
          <FileUp className="h-4 w-4" /> Ajouter une pièce
        </button>
      )}
    </div>
  );
}
